// extracted by mini-css-extract-plugin
export var entityChip = "_s8-0";
export var entityChipMissing = "_s8-1";